import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContactoInterface } from '../models/contacto-interface';
import {Title,Meta} from '@angular/platform-browser';

@Component({selector: 'ContactosComponent', 
  templateUrl: './contactos.Component.html',
 styleUrls: ['./contactos.component.scss']})
export class ContactosComponent implements OnInit {
  public nombre ="";
  public resumen = "";
  public email = "";
  public celular ="";
  pol = 0;

	ngOnInit()
	{

   window.scroll(0, 0);
	  
   this.meta.removeTag("name='title'");
   this.meta.removeTag("name='description'");
   this.title.setTitle("Contactate y habla con nosotros | Patagonia Chain");
   this.meta.addTag({name:'title',content:"Conectate con nosotros | Patagonia Chain"});
   this.meta.addTag({name:'description',content:'Ofrecemos diseño y desarrollo a medida para ayudarlo a convertir sus ideas en obras maestras digitales. Hablemos'})
   document.getElementById("pat").hidden = true;
     document.getElementById("somos").hidden = true;
       document.getElementById("serv").hidden = true;
         document.getElementById("proy").hidden = true;
           document.getElementById("con").hidden = true;
             document.getElementById("footer").hidden = true;


               let route = document.location.href;
      
      
        if(route.indexOf("https://patagonia-chain.com/politicas-de-privacidad") > -1 )
        {
              this.pol = 1;

        }
      
  
   }
 
  enviar()
  {
    
    if(this.nombre == "") 
    {
      alert("Debe ingresar su nombre");
      return;

    }
     if(this.email == "") 
    {
      alert("Debe ingresar su email");
      return;

    }
     if(this.resumen == "") 
    {
      alert("Debe ingresar la descripcion de su proyecto");
      return;

    }

     const contac = {
         "nombre": this.nombre,
         "email": this.email,
         "resumen" : this.resumen,
      };
      document.getElementById('input-submit').style.background = "#03030394"
      // console.log(typeof(testJson));
      // console.log(testJson);
      
      this.authService.newContacto(this.nombre, this.email,this.resumen, this.celular).subscribe(respuesta => {
        



        if (respuesta.Id_Mensaje === "100") {

            document.getElementById('input-submit').style.background = "green"
           document.getElementById("error").hidden =false;
          document.getElementById('error').innerHTML = "¡Se envió correctamente el mensaje!";
        

          setTimeout(() => {
             document.getElementById("error").hidden =true;
              document.getElementById('input-submit').style.background ="#295da9";
          }, 5000);

       
       
        } else {
          document.getElementById('input-submit').style.background = "red";
            document.getElementById("error").hidden =false;
            document.getElementById('error').innerHTML = "¡Hubo un error! vuelve a intentar en unos segundos";
            document.getElementById('error').style.color = "red";
           setTimeout(() => {
             document.getElementById("error").hidden =true;
             document.getElementById('input-submit').style.background ="#295da9";
          }, 5000);
        }
      });


    

  }

     constructor(private authService: AuthService, private domSanitizer: DomSanitizer, private router: Router,private title:Title, private meta: Meta ){}

   

  
}


